import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import { Button } from 'Button';
import { getRegisterButton, getRegisterButtonState } from '../getRegisterButtonConfig';
import { RegisterButtonState } from '../TuitionAndRegistration.types';

type RegisterButtonProps = {
    processingRegistration: boolean;
    registerRequiresRedirectToBrowser: boolean;
    defaultState?: RegisterButtonState;
    additionalFinancingOptionIsSelected?: boolean;
    isDisabled: boolean;
    onPress: () => void;
    className?: string;
};

// Button renders `icon` as startContent, so the trailing arrow goes in children.
export function RegisterButton({
    processingRegistration,
    registerRequiresRedirectToBrowser,
    defaultState = RegisterButtonState.review_and_register,
    additionalFinancingOptionIsSelected = false,
    isDisabled,
    onPress,
    className,
}: RegisterButtonProps): ReactElement {
    const { t } = useTranslation('back_royal');

    const registerButtonState = getRegisterButtonState({
        processingRegistration,
        registerRequiresRedirectToBrowser,
        defaultState,
        additionalFinancingOptionIsSelected,
    });

    const registerButton = getRegisterButton({ registerButtonState });
    const showsArrow = registerButtonState === RegisterButtonState.continue_to_register;

    return (
        <Button type="button" color="green" height={9} className={className} isDisabled={isDisabled} onPress={onPress}>
            {t(registerButton.text.key)}
            {showsArrow ? <FontAwesomeIcon icon={faArrowRight} /> : null}
        </Button>
    );
}
